import { render, staticRenderFns } from "./_Support.vue?vue&type=template&id=44580b5f&scoped=true&"
import script from "./_Support.vue?vue&type=script&lang=js&"
export * from "./_Support.vue?vue&type=script&lang=js&"
import style0 from "./_Support.vue?vue&type=style&index=0&id=44580b5f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44580b5f",
  null
  
)

export default component.exports